import { forwardRef } from "react";
import { useHistory } from "react-router";
import { Link as MuiLink, LinkProps } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { mergeWith } from "lodash";

const useStyles = makeStyles(() => ({
  root: {
    cursor: "pointer",
  },
}));

const Link = forwardRef(
  ({ classes = {}, ...otherProps }: LinkProps & { url?: string }, ref: any) => {
    const history = useHistory();
    const baseClasses = useStyles();
    const linkClasses = mergeWith(
      baseClasses,
      classes,
      (class1: string, class2: string) => `${class1} ${class2}`
    );

    if (otherProps.url) {
      const url: string = otherProps.url;
      return (
        <MuiLink
          ref={ref}
          {...otherProps}
          classes={linkClasses}
          onClick={() => history.push(url)}
        />
      );
    }

    return <MuiLink {...otherProps} classes={linkClasses} />;
  }
);

export default Link;
